import { useState } from "react";
import { FAQS } from "@/data";
import { SectionHeading } from "./Buttons";
import * as Icons from "lucide-react";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative py-20 md:py-28 px-4 md:px-8 bg-slate-50">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          eyebrow="Common Questions"
          title={<>Got questions?<br /><span className="text-brand-red">We've got answers.</span></>}
          align="center"
          testid="faq-heading"
        />

        <div className="mt-12 space-y-3" data-testid="faq-list">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                data-testid={`faq-item-${i}`}
                className={`bg-white rounded-2xl overflow-hidden transition-all border ${
                  isOpen ? "border-brand-red shadow-md" : "border-slate-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-trigger-${i}`}
                  className="w-full flex items-center justify-between gap-6 p-5 md:p-6 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-display font-bold text-brand-navy text-base md:text-lg leading-snug">
                    {f.q}
                  </span>
                  <div
                    className={`shrink-0 w-9 h-9 rounded-full grid place-items-center transition-all ${
                      isOpen ? "bg-brand-red text-white rotate-45" : "bg-slate-100 text-brand-navy"
                    }`}
                  >
                    <Icons.Plus className="w-4 h-4" />
                  </div>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-6 text-sm md:text-base text-slate-600 leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
